const status = [
  {
    coverageType: 'DEFAULT',
    states: [
      { text: 'home.status.paid', value: 'PAID'},
      { text: 'home.status.expired', value: 'EXPIRED' },
      { text: 'home.status.voided', value: 'VOIDED'},
      { text: 'home.status.error', value: 'ERROR'},
      { text: 'home.status.canceled', value: 'CANCELED' },
      { text: 'home.status.completed', value: 'COMPLETED' },
      { text: 'home.status.inProgress', value: 'IN_PROGRESS' },
      { text: 'home.status.failed', value: 'FAILED' },
      { text: 'home.status.ready', value: 'READY' },
      { text: 'home.status.expirationInProgress', value: 'EXPIRATION_IN_PROGRESS' },
      { text: 'home.status.updateInProgress', value: 'UPDATE_IN_PROGRESS'},
    ]
  }
]

const orderBy = [
  {
    text: 'home.order.createdAt',
    value: 'createdAt',
    order: 'desc'
  },
  {
    text: 'home.order.beneficiaryName',
    value: 'beneficiaryName',
    order: 'asc'
  },
]

const types = [
  {
    slug: 'PRESCRIPTION_DRUGS',
    value: 'PRESCRIPTION_DRUGS',
    text: 'authorizationTypes.medicalTypes.medicines',
  },
  {
    slug: 'DIAGNOSTIC_TESTS',
    value: 'DIAGNOSTIC_TESTS',
    text: 'authorizationTypes.medicalTypes.diagnostic',
  },
  {
    slug: 'MEDICAL_PROCEDURES',
    value: 'MEDICAL_PROCEDURES',
    text: 'authorizationTypes.medicalTypes.process',
  },
  {
    slug: 'GENERIC',
    value: 'GENERIC',
    text: 'authorizationTypes.medicalTypes.generic',
  },
  {
    slug: 'OUTPATIENT_CARE',
    value: 'OUTPATIENT_CARE',
    text: 'authorizationTypes.medicalTypes.outpatientCare',
  }
]

const authorizationTypes = [
  {
      subHeader: 'authorizationTypes.medicalTypes.subHeader',
      items: [
          { 
            active: false,
            value: {
              text: 'authorizationTypes.medicalTypes.outpatientCare',
              navBarText: 'authorizationTypes.navBar.outpatientCare',
              path: '/authorization/outpatient-care',
              transactionType: 'OUTPATIENT_CARE',
              productType: ''
            }
          }
      ]
  },
]

export {
  status,
  types,
  orderBy,
  authorizationTypes
}
